'use client'

import { RichText } from '@/presentation/components/rich-text'
import { type HTMLAttributes, useRef } from 'react'
import type { AutoFormWidgetsProps } from '../autoForm'
import { FieldDescription } from '../description'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type RichTextWidgetProps = AutoFormWidgetsProps & {
  initialValue?: HTMLAttributes<HTMLInputElement>['defaultValue']
}

export const RichTextWidget = (props: RichTextWidgetProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>
        {props.options?.label as string}
        <FieldDescription>{props.options?.description as string}</FieldDescription>
      </FieldLabel>

      <FieldControl>
        <input type="hidden" defaultValue={props.initialValue} ref={inputRef} />
      </FieldControl>
      <RichText
        className="bg-white prose-sm"
        placeholder={props.options?.placeholder as string | undefined}
        content={props.initialValue}
        onChange={(value) => {
          if (inputRef.current) {
            inputRef.current.value = value
          }
        }}
      />
      <FieldMessage />
    </Field>
  )
}
